import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewRoarActivityComponent } from "../../../../components/review-content/review-roar-activity/review-roar-activity.component";

@Component({
  selector: 'activity-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewRoarActivityComponent
  ],
  templateUrl: './activity-submission.component.html',
  styleUrl: './activity-submission.component.css'
})
export class ActivitySubmissionComponent implements OnInit {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  currentRoarId: string | null = null;

  ngOnInit(): void {
    if (this.roarAssignmentFormData) {
      this.currentRoarId = this.roarAssignmentFormData.roar_id;
    }
  }

  submitRoarAssignment(): void {
    this.onSaveSection3.emit({});
  }

}
